import { useDispatch } from 'react-redux';
import { get, find, isEqual } from 'lodash';
import {
  postCreditCard,
  putCreditCard,
  postUser,
  deleteCreditCard,
} from 'components/payment/mexico/claro-pagos/api';
import { setCurrentWFS } from 'action-creators/payway/currentPayment/currentWFS';
import { getExecute } from 'services/api/microfwk';
import { getFormClaroPagos } from '../utils/objectCard';
import * as c from '../constants';

const useClaroPagos = () => {
  const dispatch = useDispatch();

  const callWFS = async dataWFS => {
    const params = {
      offer_id: dataWFS.offerId,
      cpgs_user: true,
    };
    const resp = await getExecute(dataWFS.linkWFS, params);
    return resp;
  };

  const createClient = async (form, token) => {
    try {
      const resp = await postUser(form, token);
      return {
        code: 200,
        userModel: get(resp, c.RESP_DATA),
      };
    } catch (e) {
      const code = get(e, c.RESP_CODE_ERROR);
      if (code === 409) {
        return {
          code,
        };
      }
      return {
        code: `TEXT_PGS_ERRORS_CP_CODE_${code}`,
        genericError: true,
        message: get(e, c.RESP_MSG_ERROR),
      };
    }
  };

  const createCard = async (form, token, clientId) => {
    try {
      const resp = await postCreditCard(
        { ...form, cliente_id: clientId, cargo_unico: true },
        token,
      );
      return {
        code: 200,
        creditCardModel: get(resp, c.RESP_DATA),
      };
    } catch (e) {
      const code = get(e, c.RESP_CODE_ERROR);
      if (code === 409) {
        throw {
          code,
        };
      }
      if(clientId) throw {
        typeError: 'clientCreatedCardFail',
        clientId: clientId
      }
      throw {
        code: `TEXT_PGS_ERRORS_CP_CODE_${code}`,
        genericError: true,
        message: get(e, c.RESP_MSG_ERROR),
      };
    }
  };

  const createProfile = async params => {
    console.log('useSessioon', params);
    const { userSession, dataCard, dataWFS } = params;
    let cpUserId;
    let cpCreditCardToken;
    let cpGate;

    const data = getFormClaroPagos(userSession, dataCard);

    const respClient = await createClient(
      data.client,
      data.tokenClient,
      dataWFS,
    );

    if (typeof respClient.code !== 'number' || respClient?.genericError) {
      throw respClient;
    }

    if (respClient.code === 409) {
      respClient.userModel = await callWFS(dataWFS);
      let GATELIST_PATH = c.BUYLINK_LIST;
      const OBJECT_TYPE = get(respClient.userModel, c.RESP_OBJECT_TYPE);

      if (isEqual(OBJECT_TYPE, c.SUSCRIPTION_TYPE)) GATELIST_PATH = c.GATE_LIST;

      const gatesList = get(respClient.userModel, GATELIST_PATH);
      cpGate = find(gatesList, gate => gate.gateway === c.CLAROPAGOS_GATE);
      dispatch(setCurrentWFS(cpGate));
      cpUserId = get(cpGate, c.WFS_ACCOUNT);
    } else {
      cpUserId = get(respClient.userModel, c.CP_CLIENT_ID);
    }

    const respCard = await createCard(data.card, data.tokenCard, cpUserId);
    if (typeof respCard.code !== 'number' || respCard?.genericError) {
      if(cpUserId) throw {
        error: respCard,
        typeError: 'clientCreated',
        cpUserId,
      }
      throw respCard;
    }

    if (respCard.code === 409) {
      cpCreditCardToken = get(cpGate, c.WFS_ACCOUNT_TOKEN);
    } else {
      cpCreditCardToken = get(respCard, c.CP_CARD_TOKEN);
    }

    return {
      cpUserId,
      cpCreditCardToken,
      account: dataCard.number,
      cardType: dataCard.cardType,
      fingerprint: userSession.fingerprint,
      token: userSession.userToken,
      buyToken: userSession.buyToken,
    };
  };

  const updateCardCP = async (params, isEditing = false) => {
    const { accountToken, headerToken, clienId, form } = params;

    let infoParams = {
      default: true,
      client_id: clienId,
    };

    if (form.number || isEditing) {
      infoParams = { ...infoParams, ...getFormClaroPagos({}, form).card };
    } else {
      infoParams = { ...infoParams, ...form };
    }
    await putCreditCard(accountToken, infoParams, headerToken);
  };

  const deleteCardFromUser = async (tokenCard, headerToken) => {
    try {
      await deleteCreditCard(tokenCard, headerToken);
    } catch (error) {
      throw error;
    }
  };

  return {
    createClient,
    createCard,
    createProfile,
    updateCardCP,
    deleteCardFromUser,
  };
};

export default useClaroPagos;
